import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import posthog from "posthog-js";
import App from "./App.tsx";
import "./index.css";
import { APP_BUILD, APP_VERSION_STRING } from "./lib/version";
import { isTelemetryAllowedHost } from "./lib/allowedHosts";
import { bootstrap } from "./lib/appBootstrap";
import { purgeLegacyGuestBrowseKey } from "./lib/guestBrowsing";

// [referral] signup fetch/XHR interceptors are installed in index.html
// (classic <script> before module scripts) so the Supabase client cannot
// capture an unwrapped fetch reference during module init.


// One-time removal of the pre-rename guest-browse key. No sweep can reach it
// (it predates the grounded_browse_ prefix), so it is cleared here at startup.
purgeLegacyGuestBrowseKey();

// PostHog only initializes on the shared telemetry allow-list so preview
// hosts don't pollute analytics. All posthog.capture(...) calls elsewhere in
// the app safely no-op when the SDK hasn't been initialized.
if (isTelemetryAllowedHost()) {
  posthog.init("phc_t94MtNt4fjtSjB7pQiMTEiWWdWXz5T6CKdKdUGb8uQDc", {
    api_host: "https://us.i.posthog.com",
    person_profiles: "identified_only",
    capture_pageview: true,
    capture_pageleave: true,
  });
}

// Service worker auto-registers via VitePWA registerType:"autoUpdate" in real
// production only; preview/dev builds skip the PWA plugin entirely.
// Cache/SW cleanup runs in the background and can never block the mount.
bootstrap({
  appVersion: APP_BUILD,
  isDev: import.meta.env.DEV,
  versionBanner: `☕ Grounded ${APP_VERSION_STRING}`,
  mount: () => {
    createRoot(document.getElementById("root")!).render(
      <HelmetProvider>
        <App />
      </HelmetProvider>
    );
  },
});
